import React, { FC, useEffect, useState } from "react";
import { message } from "antd";

import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { IDocumentFields } from "../../../../interfaces/ICase";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  getProcedureAmountNew,
  getStratsDataNew,
} from "../../../../apis/patientService";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import { rejectJfifUpload } from "../../../../utils/fileUploadValidation";
import { fetchProcedureNew } from "../../../../models/preAuthClaimSlice";
import {
  enhancementServiceCghsNew,
  fetchEnhancementProcedureCghsNew,
  getEnhancementReason,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import dayjs from "dayjs";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
// import EnhancementCghs from "../../../../components/patient/Enhancement/CGHS/EnhancementCghs";
import EnhancementCghsNew from "../../../../components/patient/Enhancement/CGHSNEW/EnhancementCghsNew";
import { errorMessageModal } from "../../../../utils/modalMessage";
interface EnhancementProcedureForCghsContainerProps {
  createEnhancement: boolean;
  closeCreateEnhancementModal: any;
  activeKey: any; // Define prop type for the function
}
const EnhancementContainerCghsNew: FC<
  EnhancementProcedureForCghsContainerProps
> = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, hospital, preAuthClaim, preAuth, enhancement, auth } =
    useSelector((state: RootState) => state);
  const [enhancementProcedure, setEnhancementProcedure] = useState<any>([]);
  const [procedureStrats, setProcedureStrats] = useState({}); //to store strats of procedure
  const [deleteProcedureList, setDeleteProcedureList] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //to open modal for confirmation of deletion of the procedure
  const [documentTypes, setDocumentTypes] = useState([]);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [uploadResult, setUploadResult] = useState<any>([]);
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
    {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }[]
  >([]);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [caseEnhancementId, setCaseEnhancementId] = useState<string | null>(
    null
  );
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [isFetchingProcedures, setIsFetchingProcedures] =
    useState<boolean>(false);
  const [enhancementReasonOptions, setEnhancementReasonOptions] = useState<any>(
    []
  );

  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number
  ) => {
    try {
      // const documentList = await getDocuments(props?.schemeMetaDataId);
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );
        setDocumentTypes(AllDocumentList?.["Enhancement"]);
      }
    } catch (err) {
      // errorMessage("Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedureNew({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS NEW"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
              benType: patients?.fetchBasicDetails?.patientResponse?.cardCategory ? patients?.fetchBasicDetails?.patientResponse?.cardCategory?.toLowerCase()?.includes("Gen"?.toLowerCase()) ? "DGW" : patients?.fetchBasicDetails?.patientResponse?.cardCategory?.toLowerCase()?.includes("Private"?.toLowerCase()) ? "DPW" : "DSPW" : null
          })
        );
      }
      fetchDocuments(
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
    props?.createEnhancement,
  ]);
  const formattedAccreditationOptions: Array<{ label: string; value: string }> =
    [
      { label: "NABH", value: "NABH" },
      { label: "NABL", value: "NABL" },
      { label: "NON NABL", value: "NON NABL" },
      { label: "NON NABH", value: "NON NABH" },
    ]?.map((option) => ({
      value: option?.value + "~" + option?.label,
      label: option.label,
    }));
  const formattedTreatingDoctorsOptions: Array<{
    label: string;
    value: string;
  }> = [{ treatingDoctorCode: "OTHERS", treatingDoctorName: "OTHERS" }]?.map(
    (option) => ({
      value: option?.treatingDoctorCode + "~" + option?.treatingDoctorName,
      label: option?.treatingDoctorName,
    })
  );
  const formattedProcedureReferral: Array<{ label: string; value: string }> = [
    { label: "REFERRAL", value: "referral" },
    { label: "NON REFERRAL", value: "non referral" },
  ]?.map((option) => ({
    value: option?.value + "~" + option?.label,
    label: option.label,
  }));
  const formattedProceduresOptions: Array<{ label: string; value: string }> =
    preAuthClaim?.procedureDropDown
      ? preAuthClaim?.procedureDropDown?.map((option: any) => ({
          value: JSON.stringify(option),
          label: option?.procedureName,
          extra: option?.amount
        }))
      : [];

  const handleGetProcedureAmount = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureAmountRes = await getProcedureAmountNew(newFormData);
      return procedureAmountRes;
    } catch (err: any) {
      // errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleGetProcedureStrats = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureStrats = await getStratsDataNew(newFormData);
      setProcedureStrats((prevStrats) => ({
        ...prevStrats,
        [formData.procedureId]: procedureStrats,
      }));
      return procedureStrats;
    } catch (err: any) {
      errorMessageModal(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handleFetchProcedureList = async () => {
    try {
      setIsFetchingProcedures(true);
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedureCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        setEnhancementProcedure(res);
        setIsFetchingProcedures(false);
      }
    } catch (err: any) {
      setIsFetchingProcedures(false);
      errorMessageModal(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleDeleteProcedure = async (procedure: any) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        // const formData = {
        //   caseTherapyId,
        //   proccode: procedureCode,
        // };
        setDeleteProcedureList((prevList) => [...prevList, procedure]);
        // await deleteEnhancementProcedure(portalMetaData.portalMetaDataIdsList[0], formData);
        successMessage("Procedure added in archieve list");
        return true;
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      return false;
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  const handleSubmitEnhancementProcedure = async (
    values: any,
    enhancementReason: any
  ) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const formData = {
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          claimId: preAuth?.portalData?.casePreAuthCghs?.claimId,
          registrationId: preAuth?.portalData?.schemeRegistrationId,
          regnId: preAuth?.portalData?.schemeRegistrationId,
          documentUrls: uploadedDocumentUrl || [],
          enhancementProceduresRequestList: values?.length > 0 ? values : [],
          deleteProcList: deleteProcedureList,
          status: true,
          dateOfAdmission: patients?.fetchBasicDetails?.visitInfoResponse?.doa,
          dod: patients?.fetchBasicDetails?.visitInfoResponse?.dod,
          enhancementReason: enhancementReason,
        };

        await enhancementServiceCghsNew.saveEnhancementData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          caseEnhancementId,
          formData
        );
        props?.closeCreateEnhancementModal();
        setUploadedDocumentUrl([]);
        setEnhancementProcedure([]);
        setDeleteProcedureList([]);
        form.resetFields();
        await getTimelineDetail();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
    } catch (err: any) {
      errorMessageModal(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleOk = (procedure: any) => {
    handleDeleteProcedure(procedure);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleFileChange = (documentType: string) => (e: any) => {
    if (rejectJfifUpload(e)) return;
    if (Array.isArray(e)) {
      return e;
    }
    if (e?.file) {
      setUploadResult([]);
      setSelectedFile({ file: e.file, documentType: documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setPreviewModalVisible(true);
    }
    return e?.target?.files;
  };
  const handleUpload = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);
    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }
    try {
      const documentRes = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap();
      // const updatedDocuments = updateOrAddDocument(
      //   uploadedDocumentUrl,
      //   documentRes
      // );

      if (
        documentRes?.[0]?.documentLabelType === "justification for enhancement"
      ) {
        setUploadResult(documentRes);
      }
      const updatedDocuments = [...uploadedDocumentUrl, ...documentRes];
      setUploadedDocumentUrl(updatedDocuments);
      setPreviewModalVisible(false);
      message.success(
        `${documentRes?.[0]?.documentLabelType} uploaded successfully`
      );
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };
  const updateOrAddDocument = (
    uploadedDocumentUrl: {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }[],
    documentRes: {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }
  ): {
    documentUrl: string;
    documentType: string;
    documentLabelType: string;
    documentName: string;
    deficiencyCheckStatus: any;
    id: number;
  }[] => {
    const updatedDocuments = [...uploadedDocumentUrl];
    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });
    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };
  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (err: any) {
      errorMessage("Please, Try again later");
    }
  };
  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const deleteDocument = uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    setUploadedDocumentUrl(newUpdatedDocumentList);
    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
        // message.success("Document Deleted Successfully");
      } catch (err) {
        console.error(err);
      }
    }
  };
  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocument?.id) {
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocument?.id)
        );
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };
  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };
  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };
  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const missingDocumentIndex = values?.items?.findIndex(
        (item: any) => !item?.documents || item?.documents?.length === 0
      );

      if (missingDocumentIndex !== -1) {
        errorMessageModal(`Document is mandatory for items`);
        return;
      }

      const updatedValues = values?.items?.map((value: any) => {
        let result: any = {
          ...value,
          procedureReferral: value?.procedureReferral?.split("~")?.[0],
          procedureReferralName: value?.procedureReferral?.split("~")?.[1],
          accreditationStatus: value?.accreditationStatus?.split("~")?.[0],
          accreditationStatusName: value?.accreditationStatus?.split("~")?.[1],
          treatingDoctorCode: value?.treatingDoctor?.split("~")?.[0],
          treatingDoctor: value?.treatingDoctor?.split("~")?.[1],
          treatmentStartDate: value?.treatmentStartDate
            ? dayjs(value?.treatmentStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          ...JSON.parse(value?.procedureCode),
          stratsId: JSON.parse(value?.procedureCode)?.id,
          procedureAmount: value?.procedureAmount,
          status: true,
        };
        if (value?.stratOptionValue) {
          result = { ...result, ...JSON.parse(value.stratOptionValue) };
        }
        delete result?.["id"];
        return result;
      });
      await handleSubmitEnhancementProcedure(
        updatedValues,
        values?.enhancementReason
      );
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please fill all details before submitting");
      }
    }
  };

  const currentStageId = preAuth?.stepperData?.currentVisitStage?.visitStageId;
  const currentStep = preAuth?.currentStep;
  const visitStages = preAuth?.stepperData?.visitStages;
  const stepStageId = visitStages?.[currentStep]?.visitStageId;

  const handleGetEnhancementReason = async () => {
    try {
      const res = await getEnhancementReason();
      const formattedOptions = res?.reasonslist?.map((option: any) => ({
        value: option?.reasoncode,
        label: option?.reasondesc,
      }));

      setEnhancementReasonOptions(formattedOptions);
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (props?.createEnhancement) {
      handleFetchProcedureList();
      handleGetEnhancementReason();
    }
  }, [props?.createEnhancement]);

  return (
    <div style={{ padding: "14px" }} className="Deepak">
      <EnhancementCghsNew
        addNewEnhancementModal={props?.createEnhancement}
        closeCreateEnhancementModal={props?.closeCreateEnhancementModal}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        isFetchingPortalData={isFetchingProcedures}
        enhancementProcedure={enhancementProcedure}
        formattedAccreditationOptions={formattedAccreditationOptions}
        formattedTreatingDoctorsOptions={formattedTreatingDoctorsOptions}
        formattedProcedureReferral={formattedProcedureReferral}
        formattedProceduresOptions={formattedProceduresOptions}
        handleGetProcedureAmount={handleGetProcedureAmount}
        handleGetProcedureStrats={handleGetProcedureStrats}
        patientDetails={patients?.fetchBasicDetails}
        procedureStrats={procedureStrats}
        handleDeleteProcedure={handleDeleteProcedure}
        handleSubmitEnhancementProcedure={handleSubmitEnhancementProcedure}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleOk={handleOk}
        form={form}
        documentTypes={documentTypes}
        documentUrls={uploadedDocumentUrl}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
        enhancementReasonOptions={enhancementReasonOptions}
        uploadResult={uploadResult}
        setUploadResult={setUploadResult}
      />
      <FilePreviewModal
        isVisible={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.lastModified || "no-file"}
        isLoading={enhancement?.isLoading}
      />

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={uploadedDocumentUrl}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setUploadedDocumentUrl}
        activeKey={props?.activeKey}
        clickedActiveTab={clickedActiveTab}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        isIntimated={
          preAuth?.stepperData?.visitStages?.find(
            (stage: any) =>
              String(stage?.visitStageId) === String(props?.activeKey),
          )?.intimated
        }
      />
    </div>
  );
};
export default EnhancementContainerCghsNew;
